import { useEffect, useState, useContext } from 'react';

import { RightOutlined } from '@ant-design/icons';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';

const SearchListPop = ({ hidePop, searchKeyWord, handleClickKeyWord, searchList }) => {
  const { resourceData } = useContext(LayoutContext);
  const [associationalWordList, setAssociationalWordList] = useState([]); // 联想词
  const listClassName = 'text-[12px] leading-[16px] mb-[10px]';

  useEffect(() => {
    setAssociationalWordList(highlightKeyWord(searchList, searchKeyWord));
  }, [searchKeyWord, searchList]);

  function highlightKeyWord(dataList, keyWord) {
    return dataList
      .map((data) => {
        if (data.type === 'brand' || data.type === 'catalog') {
          data.wordArr[0].renderWord = data.wordArr[0].itemValue.replace(
            keyWord.toUpperCase(),
            '<span>' + keyWord.toUpperCase() + '</span>'
          );
        } else {
          data.renderWord = data.word.replace(keyWord.toUpperCase(), '<span>' + keyWord.toUpperCase() + '</span>');
        }
        return data;
      })
      .slice(0, 10); // 只显示10条
  }

  function globalSearch({ word, keyWordIdx, type, tipType }) {
    handleClickKeyWord({ clickedkeyWord: word, keyWordIdx, type, tipType });
    hidePop();
  }

  return (
    <>
      <ul className={listClassName}>
        {associationalWordList.map((item, i) => {
          const liClassName = i === 9 ? 'mb-[10px]' : '';
          let content = (
            <li
              onClick={() =>
                globalSearch({
                  ...item,
                  keyWordIdx: i,
                  type: 'suggestion',
                  tipType: item.type,
                })
              }
              className={`${liClassName} hover:text-lcBlue flex h-[32px] cursor-pointer items-center justify-between px-[20px] hover:bg-[#E8F5FC]`}
              key={i}
            >
              <span className="*:text-lcBlue" dangerouslySetInnerHTML={{ __html: item.renderWord }}></span>
            </li>
          );

          if (item && item.word && (item.word.includes('~catalogId') || item.word.includes('~brandId'))) {
            let urlText = 'catalog';
            if (item.wordArr[1] && item.wordArr[1].itemKeyArr && item.wordArr[1].itemKeyArr[0] == 'brandId') {
              //品牌
              urlText = 'brand';
            }
            content = (
              <a
                href={`${resourceData?.projectConfigVO?.lcscListUrl}/${urlText}/${item.wordArr[1].itemKeyArr[1]}.html${window.isMro ? '?mro=1' : ''}`}
                target="_blank"
                className={`${liClassName} hover:text-lcBlue flex h-[32px] items-center justify-between px-[20px] hover:bg-[#E8F5FC]`}
                key={i}
              >
                <span
                  className="*:text-lcBlue"
                  dangerouslySetInnerHTML={{
                    __html: item.wordArr[0].renderWord,
                  }}
                ></span>
                <span className="flex items-center text-[#56657F]">
                  <span className="mr-[6px]">进入{urlText === 'brand' ? '品牌' : '类目'}</span>
                  <RightOutlined style={{ fontSize: '9px' }} />
                </span>
              </a>
            );
          }
          return content;
        })}
      </ul>
    </>
  );
};

export default SearchListPop;
